import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["locale", "children"];
import { jsx } from 'react/jsx-runtime';
import { I18nProvider } from '@react-aria/i18n';
/** Provides internationalized strings to date related components. */

var DateI18nProvider = function DateI18nProvider(_ref) {
  var locale = _ref.locale,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx(I18nProvider, _objectSpread(_objectSpread({}, rest), {}, {
    locale: "".concat(locale, "-u-ca-default"),
    children: children
  }));
};

export { DateI18nProvider };